module.exports = __webpack_public_path__ + "static/images/icon-gen.1e2ac00.png";